module.exports = __webpack_public_path__ + "static/media/React.380f0da9.jpg";